import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

/**
 * GitHub OAuth callback bridge — the backend redirects the browser here
 * with `?github=connected&login=...` (success) or `?github_error=...` (failure).
 * We surface a toast and bounce the user back to /dashboard.
 *
 * Note: the actual code-for-token exchange happens server-side at
 * /api/github/oauth/callback before the browser ever lands here, so this page
 * is purely cosmetic.
 */
export default function GitHubCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const ok = params.get("github");
    const err = params.get("github_error");
    const login = params.get("login");
    if (err) {
      toast.error(`GitHub connection failed: ${err}`);
    } else if (ok === "connected") {
      toast.success(`GitHub connected as @${login || "you"}`);
    }
    nav("/dashboard", { replace: true });
  }, [params, nav]);

  return (
    <div className="container-narrow py-20 text-center text-ink2" data-testid="github-callback-page">
      Finalizing GitHub connection…
    </div>
  );
}
